import React from 'react'
import {handle} from './events'
import {Group, Text} from 'react-konva'
import {register} from './utils'
import {addGameObject} from './system'
import {sprite} from './system/sprite'

function Sprite() {
    this.SHOW_ME = true
    return (
        <Group>
            <Text fill="#fff" align="center" fontSize={30} text={this.$.score}/>
        </Group>
    )
}

const score = register('score', {
    postInitialize() {
        this.configure()
        this.$.setState('waiting')
    },
    states: {
        waiting: {
            enter() {
                this.$.visible = false
                this.configure()
            },
        },
        go: {
            enter() {
                this.$.visible = true
            },
            methods: {
                update(dt) {
                    this.$.y -= dt * 200
                    this.$.opacity -= dt * 1
                    if (this.$.opacity < 0.01) {
                        this.$.setState('waiting')
                    }
                },
            },
        },
    },
    methods: {
        configure() {
            this.$.x = 0
            this.$.y = 0
            this.$.scale = 2.4
            this.$.opacity = 1
        }
    },
})

let scores = []
let currentScore = 0

export function showScore(value, position) {
    let score = scores[currentScore++ % scores.length]
    score.behaviours.state = 'waiting'
    score.score = value
    score.x = position.x
    score.y = position.y
    score.setState('go')
}

handle('initializeGame', () => {
    for (let i = 0; i < 10; i++) {
        scores.push(
            addGameObject(
                {z: 3000},
                {
                    score,
                    ...sprite.config({
                        Sprite,
                    }),
                }
            )
        )
    }
})
